export default __webpack_public_path__ + "static/media/NissanBG.28715960.png";